import React from 'react';
import PropTypes from "prop-types";

export default function PaperTicketSVG(props) {
  return (
    <svg width={props.styles.width} height={props.styles.height} viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>d2704a5e-496c-45c6-b597-bf9dd65dda70@1.00x</title>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icon/Ticket-Type/Paper" fill={props.styles.fill}>
          <path d="M22.9247525,1.9009901 L22.2277228,4.37227723 L27.360396,5.25940594 L24.0019802,24.2693069 L21.150495,8.04752475 L19.9465347,1.39405941 L19.6930693,0 L17.5386139,0.316831683 L12.849505,1.14059406 L12.5960396,1.83762376 C12.2792079,2.66138614 11.5188119,3.2950495 10.6316832,3.48514851 C9.74455446,3.61188119 8.85742574,3.2950495 8.22376238,2.5980198 L7.78019802,2.02772277 L6.95643564,2.15445545 L1,3.2950495 L6.06930693,32 L15.8277228,30.2891089 L25.2059406,31.9366337 L30.2752475,3.23168317 L22.9247525,1.9009901 L22.9247525,1.9009901 Z M17.6653465,2.97821782 L21.8475248,26.6772277 L8.0970297,29.0217822 L3.91485149,5.32277228 L6.89306931,4.81584158 C8.03366337,5.82970297 9.61782178,6.27326733 11.1386139,6.01980198 C12.6594059,5.76633663 13.990099,4.81584158 14.6871287,3.48514851 L17.6653465,2.97821782 Z M9.60997703,19.1242519 L8.36191366,19.3442598 L9.24194535,24.3365133 L10.4900087,24.1165053 L9.60997703,19.1242519 Z M12.7084261,18.5661972 L10.8363311,18.8962091 L11.7163628,23.8884626 L13.5884578,23.5584507 L12.7084261,18.5661972 Z M15.1832238,18.1175762 L13.9351604,18.3375842 L14.8151921,23.3298376 L16.0632554,23.1098297 L15.1832238,18.1175762 Z M18.2843152,17.5568032 L16.4122202,17.8870051 L17.2927588,22.8792586 L19.1648539,22.5490566 L18.2843152,17.5568032 Z" id="tickets_outline"></path>
        </g>
      </g>
    </svg>
  );
}

PaperTicketSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};
